import { render, staticRenderFns } from "./MpWeakness.vue?vue&type=template&id=d9e61c40&"
import script from "./MpWeakness.vue?vue&type=script&lang=js&"
export * from "./MpWeakness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports